import React from 'react';
import color from '@/styles/mobile/color';
import styled from '@emotion/styled';

const uiColor = color.ui;

const BarcodeItemContainer = styled.div`
  background-color: #e3e6e8;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 38.4vw;
  & > * {
    margin: 0;
  }
  @media (orientation: landscape) {
    width: 30vw;
    height: 16vw;
    padding: 2.5vw;
  }
`;

const BarcodeName = styled.span`
  margin-top: 4vw;
  font-size: 3.6vw;
  line-height: 5vw;
  color: ${uiColor.divider};
  @media (orientation: landscape) {
    font: 1.8vw/1.8vw 'Roboto', sans-serif;
    margin: 0;
  }
`;

const BarcodeImg = styled.img`
  width: 45.1vw;
  height: 18.8vw;
  margin-top: 2vw;
  @media (orientation: landscape) {
    width: 23.35vw;
    height: 6.6vw;
    margin: 0;
  }
`;

const BarcodeLabel = styled.div`
  width: 40vw;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  font: 3.6vw/5vw 'Roboto', sans-serif;
  @media (orientation: landscape) {
    width: 20vw;
    font: 1.8vw/2.5vw 'Roboto', sans-serif;
  }
`;

const BarcodeItem = ({ barcode }) => {
  return (
    <BarcodeItemContainer>
      <BarcodeName>{barcode.name}</BarcodeName>
      <BarcodeImg src={barcode.imgUrl} alt={barcode.name} />
      <BarcodeLabel>
        {barcode.letter.split('').map((letter, i) => (
          <span key={i}>{letter}</span>
        ))}
      </BarcodeLabel>
    </BarcodeItemContainer>
  );
};

export default BarcodeItem;
